import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum NicotineAssets {
    BODY = "NicotineBODY",
    BRAIN = "NicotineBRAIN",
    LUNGS = "NicotineLUNGS",
    WINDPIPE = "NicotineWINDPIPE",

    AUDIO = "NicotineAUDIO",
    HAPPY_JINGLE = "NicotineHAPPY_JINGLE",

    SMOKE = "NicotineSMOKE",
    SWIRL = "NicotineSWIRL",
    RED_BRAIN = "NicotineRED_BRAIN",
    GREEN_BRAIN = "NicotineGREEN_BRAIN",
    GRAY_BRAIN = "NicotineGRAY_BRAIN",
}

export function loadAssets(game: Phaser.Game) {
    game.load.image(NicotineAssets.BODY, CCUtils.asset("addiction/nicotine-and-addiction/body.png"))
    game.load.image(NicotineAssets.BRAIN, CCUtils.asset("addiction/nicotine-and-addiction/brain.png"))
    game.load.image(NicotineAssets.LUNGS, CCUtils.asset("addiction/nicotine-and-addiction/lungs.png"))
    game.load.image(NicotineAssets.WINDPIPE, CCUtils.asset("addiction/nicotine-and-addiction/windpipe.png"))

    game.load.audio(NicotineAssets.AUDIO, CCUtils.asset("addiction/nicotine-and-addiction/nicotine-and-addiction.mp3"))
    game.load.audio(NicotineAssets.HAPPY_JINGLE, CCUtils.asset("addiction/nicotine-and-addiction/happy-jingle.wav"))

    game.load.spritesheet(NicotineAssets.SMOKE, CCUtils.asset("addiction/nicotine-and-addiction/smoke.png"), 39, 74)
    game.load.spritesheet(NicotineAssets.SWIRL, CCUtils.asset("addiction/nicotine-and-addiction/swirl.png"), 208, 216)
    game.load.spritesheet(NicotineAssets.RED_BRAIN, CCUtils.asset("addiction/nicotine-and-addiction/red-brain.png"), 168, 175)
    game.load.spritesheet(NicotineAssets.GREEN_BRAIN, CCUtils.asset("addiction/nicotine-and-addiction/green-brain.png"), 168, 175)
    game.load.spritesheet(NicotineAssets.GRAY_BRAIN, CCUtils.asset("addiction/nicotine-and-addiction/gray-brain.png"), 168, 175)
}
